import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
    selector: 'app-apropos-ecorec',
    templateUrl: './apropos-ecorec.component.html',
    styleUrls: ['./apropos-ecorec.component.css'],
    standalone: false
})
export class AproposEcorecComponent implements OnInit {

  objetInfo: any = {};
  error = '';
  resultOp4: any;
  @ViewChild('msgLicence') msgLicence;
  listUserConnecter :any[] = [];
  constructor(public common: CommonService) { }

  ngOnInit() {
    this.objetInfo = this.common.objetApropos || {};
    this.listUserConnecter = this.objetInfo?.LIST_USER_CONNECTED || [];
  }
  
  afficheUserConnecter() {
    this.common.openModalDmdEcoGED(this.common.modalService, this.msgLicence);
  }

}
